import { UsersPreferenceData } from 'src/store/interface';
import { mixpanelObject } from 'src/utils/analytics';
import { settingsPropertySetter } from 'src/utils/analytics/mixpanel/mixpanelHelper';
import { HTTP_METHODS } from 'src/utils/constants/HttpMethodsConstants';

import {
  getLocalStorage,
  setCookie,
  setLocalStorage
} from '../../../utils/browserStorageHandler';
import { SETTINGS_API_URL } from '../../../utils/constants/ApiConstants';
import {
  CONTENT_LANGUAGES_COOKIE,
  DISPLAY_LANGUAGE_COOKIE
} from '../../../utils/constants/cookieConstants';
import { SETTINGS } from '../../../utils/constants/localStorageConstants';
import { httpService } from '../../fetch/HttpService';
import { KeyValue } from '../../fetch/Types';
import { getAPIHeaders } from '../Login/LoginService';

const fetchUserSettingsData = async () => {
  const headers = getAPIHeaders();
  try {
    return await httpService.fetchApiData({
      url: SETTINGS_API_URL,
      type: HTTP_METHODS.GET,
      headers
    });
  } catch (error) {
    return await httpService.logApiError(error);
  }
};

const sortCSVString = (string = '') => {
  return string.split(',').sort().join(',');
};

export const getRegisteredUserSettings = async (
  locale: string,
  userInitialData: any
) => {
  try {
    const userSettings: KeyValue<string, string>[] = userInitialData?.settings
      ? userInitialData?.settings
      : await fetchUserSettingsData();

    const userPreferenceData: UsersPreferenceData = {
      display_language: locale || 'en',
      content_language: locale === 'en' ? 'en,hi' : 'en,' + locale
    };

    if (userSettings && !Array.isArray(userSettings)) {
      return (userSettings as any)?.code;
    }

    userSettings &&
      Array.isArray(userSettings) &&
      userSettings.map((element) => {
        if (element.key === 'partner') {
          userPreferenceData[element.key] = JSON.parse(element.value);
        } else {
          (userPreferenceData[
            element.key as keyof UsersPreferenceData
          ] as string) = element.value;
        }
      });

    userPreferenceData.display_language &&
      setCookie(DISPLAY_LANGUAGE_COOKIE, userPreferenceData.display_language);
    const alphabeticallySortedContentLanguages = sortCSVString(
      userPreferenceData.content_language
    );
    setCookie(CONTENT_LANGUAGES_COOKIE, alphabeticallySortedContentLanguages);
    //TODO: if setting api failed, getLocalStorage(SETTINGS) will return undefined. JSON.parse(undefined) will throw error.
    const registerUserSettings = {
      ...JSON.parse(getLocalStorage(SETTINGS) as string),
      display_language: userPreferenceData.display_language,
      content_language: userPreferenceData.content_language,
      recent_search: userPreferenceData.recent_search,
      partner: userPreferenceData.partner,
      parental_control_v2: userPreferenceData.parental_control_v2
    };
    setLocalStorage(SETTINGS, registerUserSettings);
    //mixpanel events
    userSettings && settingsPropertySetter(mixpanelObject, userSettings);
    return userPreferenceData;
  } catch (err) {
    console.error('user setting API failing', err);
  }
};
